import { Breakpoint, Theme, useMediaQuery } from '@mui/material';

const useIsMobile = (key: Breakpoint | number = 'lg') =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down(key));

export default useIsMobile;
